module.exports = __webpack_public_path__ + "img/up-right.e6dc1bc2.svg";